import { useCallback } from "react";
import { Select } from "antd";
import { useRequest } from "ahooks";
import { setting as settingService } from "@/services";

function ReportTypeSelect({ value, onChange, token }) {
  const { data = { results: [] }, loading } = useRequest(
    () => settingService.listReportType({}, token),
    {
      ready: !!token,
      refreshDeps: [token],
    }
  );

  const changeHandler = useCallback(
    (value) => {
      onChange(value);
    },
    [onChange]
  );

  const optionItems = data.results.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.name}
    </Select.Option>
  ));

  return (
    <Select
      loading={loading}
      value={value}
      onChange={changeHandler}
      placeholder="空"
      allowClear={true}
    >
      {optionItems}
    </Select>
  );
}

export default ReportTypeSelect;
